import Swiper from 'swiper/dist/js/swiper';
import isIEbrowser from '../../../resources/scripts/helpers/is-IE';

class BrixImageCarousel {
  static init(...parameters) {
    return new BrixImageCarousel(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
    const IE = isIEbrowser();
    this.swiperContainer = selector.querySelector('.swiper-container');
    this.swiperPagination = selector.querySelector('.swiper-pagination');
    this.swiperNext = selector.querySelector('.swiper-navigation-slide-next');
    this.swiperPrev = selector.querySelector('.swiper-navigation-slide-prev');

    this.mySwiper = new Swiper(this.swiperContainer, {
      pagination: {
        el: this.swiperPagination,
        type: 'bullets',
        clickable: true,
        bulletElement: 'div',
      },
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev,
      },
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      loopedSlides: 10,
    });

    if (this.mySwiper && IE) {
      window.objectFitPolyfill();
    }

    window.addEventListener('resize', () => {
      // Render on resize to update swiper
      this.mySwiper.update();
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-image-carousel', BrixImageCarousel.init);
}
